import { CellContext } from "@tanstack/react-table";
import clsx from "clsx";
import { ChevronDown } from "lucide-react";

export default function ExpansionCell<RowType>(
  props: CellContext<RowType, any>
) {
  const {
    row: { getCanExpand, getIsExpanded },
  } = props;

  if (!getCanExpand()) return null;

  return (
    <ChevronDown
      size="16"
      className={clsx("transition-transform duration-300", {
        "rotate-180": getIsExpanded(),
      })}
    />
  );
}
